import React, { useMemo } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { SecondaryPoWrapper } from '../../elements';
import { DH } from '../../../../utils/dataHooks';
import { MorePaymentOptions } from '../../../MorePaymentOptions';
import { getButtonsConfigByGroups } from '../../utils/getButtonsViewConfig';
import { ExpressButtonsInsideShowMore, ExpressButtonsOnTopLevel } from '../ExpressButtons';
import { classes } from '../../styles.st.css';
import { useSelector } from '../../../../store';
import { selectAvailableMethodsInfo } from '../../../../selectors/payment';

const TRANSITION_TIMEOUT = 400;

export interface VerticalListViewProps {
  onMorePaymentOptionsClick(): void;
  isCollapsed: boolean;
}
export const VerticalListView: React.FC<VerticalListViewProps> = (props) => {
  const { isCollapsed, onMorePaymentOptionsClick } = props;
  const availablePmsList = useSelector(selectAvailableMethodsInfo);
  const viewConfig = useMemo(() => getButtonsConfigByGroups(availablePmsList), [availablePmsList]);

  return (
    <div data-hook={DH.Widget.PMList} className={classnames(classes.layout, classes.vertical)}>
      <ExpressButtonsOnTopLevel viewConfig={viewConfig} />
      {viewConfig.insideShowMore.length > 0 && (
        <>
          <CSSTransition
            in={!isCollapsed}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              enter: classes.enter,
              enterActive: classes.enterActive,
              enterDone: classes.enterDone,
            }}
          >
            <SecondaryPoWrapper>
              <ExpressButtonsInsideShowMore viewConfig={viewConfig} />
            </SecondaryPoWrapper>
          </CSSTransition>
          <CSSTransition
            in={isCollapsed}
            timeout={TRANSITION_TIMEOUT}
            classNames={{
              exit: classes.exit,
              exitActive: classes.exitActive,
              exitDone: classes.exitDone,
            }}
          >
            <div data-hook={DH.Widget.MorePoWrapper} data-hidden={!isCollapsed}>
              <MorePaymentOptions onClick={onMorePaymentOptionsClick} />
            </div>
          </CSSTransition>
        </>
      )}
    </div>
  );
};
